import FlashcardComponent from '@views/search/flashcards/show';
import SearchAttachmentView from '@/views/search/attachment';
import SearchComponent from '@views/search/index';

export default [
  {
    path: '/search',
    name: 'search#index',
    component: SearchComponent,
    meta: {
      disableSearchbar: true,
      header: false,
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/search/flashcards/:flashcardId?',
    name: 'search#flashcard',
    component: FlashcardComponent,
    meta: {
      header: true,
      resourceOptional: true,
      masteryFooter: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/search/topics/:topicId?/:subtopicId?',
    name: 'search#topic',
    component: () => import('@views/topics/show'),
    meta: {
      footer: true,
      header: true,
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/search/attachments/:attachmentId',
    name: 'search#attachment',
    component: SearchAttachmentView,
    meta: {
      footer: true,
      header: true,
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
];
